<header class="top-header-area">
    <div class="container" [ngClass]="{'container-fluid': router?.url === '/home' || router?.url === '/home-11'}">
        <div class="row align-items-center">
            <div class="col-lg-5 col-md-5">
                <ul class="social-links">
                    <li>Follow Us:</li>
                    <li><a href="https://www.facebook.com/people/A-M-Media-and-Sports/61575779366522/"
                            target="_blank"><i class="icofont-facebook"></i></a></li>
                    <li><a href="https://x.com/ammediasports"><i class="icofont-x"></i></a></li>
                    <li><a href="https://www.instagram.com/ammediasports/"><i class="icofont-instagram"></i></a></li>
                    <li><a href="https://www.linkedin.com/company/am-media-and-sports-pvt-ltd"><i
                                class="icofont-linkedin"></i></a></li>
                </ul>
            </div>

            <div class="col-lg-7 col-md-7">
                <ul class="header-info">
                    <li><a routerLink="/about">About</a></li>
                    <li><a routerLink="/privacy-policy">Privacy Policy</a></li>
                </ul>
            </div>
        </div>
    </div>
</header>